import { useContext, useState } from "react";
import ReissuePassword from "../parts/ReissuePassword";
import { AppFunctions, AppFunctionsContext } from "./App";

/**
 * フッタ部分を表すコンポーネント
 * 
 * @returns 
 */
export default function Footer(): JSX.Element {

	/** パスワード再発行画面を表示するか？ */
	const [reissuePassword, setReissuePassword] = useState<boolean>(false);

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	/** ログイン情報 */
	const login = appFunctions?.getLogin();

	/**
	 * パスワード不明リンククリック時用イベント
	 */
	const handlePasswordClick = () => {
		setReissuePassword(true);
	};

	// 描画する
	return (
		<>
			<ul className="nav pull-right">
				{login != undefined ? (
					<p><a href="https://www.naviexp.com/support_form.html" target="_blank" className="brand">ナビエクスプレス　お問い合わせ窓口</a></p>
				) : (
					<p style={{ marginBottom: '20px' }}>パスワードがご不明な場合は、<a className="brand" onClick={handlePasswordClick}>こちら</a></p>
				)}
				<a href="https://www.nttcoms.com/service/naviexp/" target="_blank"><img id="imglogo" width="231" height="52" src="images/NELogoS.png" style={{ marginBottom: '20px' }} /></a>
				<p><img src="images/copyright.gif" width="280" height="22"></img></p>
			</ul>
			{reissuePassword &&
				<ReissuePassword onClose={() => setReissuePassword(false)} />}
		</>
	);
}